<template>
  <div class="custom-page-clock-container">
    <!--弹窗选择类型-->
    <div v-if="sceneType===0" class="type-choice">
      <div class="left">
        <div class="clock-style-setting" v-if="data">
          <style-setting :data="data" :collapses="data.styleList" @recoverSetting="recoverSetting"></style-setting>
        </div>
        <div class="operation">
          <el-button type="primary" @click="save">确定</el-button>
          <el-button @click="closeDialog">关闭</el-button>
        </div>
      </div>
      <div class="right">
        <div class="right-content" :class="{'choice':choiceFlag===0}" @click="choice(0)">
          <img src="./assets/images/clock1.png" alt="">
          <span class="el-icon-success" v-show="choiceFlag===0"></span>
        </div>
        <div class="right-content" :class="{'choice':choiceFlag===1}" @click="choice(1)">
          <div class="date">{{ getDate }}</div>
          <span class="el-icon-success" v-show="choiceFlag===1"></span>
        </div>
        <div class="right-content" :class="{'choice':choiceFlag===2}" @click="choice(2)">
          <div class="date date-now">{{ nowDate }}</div>
          <span class="el-icon-success" v-show="choiceFlag===2"></span>
        </div>
        <div class="right-content clock-content" :class="{'choice':choiceFlag===3}" @click="choice(3)">
          <img src="./assets/images/clock2.png" alt="">
          <span class="el-icon-success" v-show="choiceFlag===3"></span>
        </div>
      </div>
    </div>
    <!--执行-->
    <div class="clock-runtime" v-if="sceneType===1">
      <div :style='getFontStyle(data.textFont)' class="date" v-if="data.clockParams.styleType==='number'">{{time}}</div>
      <div v-else-if="data.clockParams.styleType==='clock'">
        <clockPlugIn :time="time" :color="data.textFont.font.color || '#ccc'"></clockPlugIn>
      </div>
      <div class="date" v-else-if="data.clockParams.styleType==='date'" :style='getFontStyle(data.textFont)'>{{ getDate }}</div>
      <div class="date" :style='getFontStyle(data.textFont)' v-else>{{ nowDate }}</div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import clockPlugIn from 'vue-clock2'
import styleSetting from './style-setting/style-setting'
import setStyle from '../../../public/setStyle'
export default {
  name: 'clock',
  props: {
    data: {
      type: Object,
      required: true
    },
    sceneType: {
      type: Number,
      default: 0
    },
    // 因为运行页也用的是同一个组件，但是 getStyleSetting 不需要，所以不设置 required
    getStyleSetting: {
      type: Function,
      default: function (args) {}
    },
    getStyleWithStyleList: Function
  },
  mixins: [setStyle],
  components: {clockPlugIn, styleSetting},
  data () {
    let date = moment().format('YYYY/MM/DD')
    let splitDate = date.split('/')
    let disposeDate = `${splitDate[0]}年${splitDate[1]}月${splitDate[2]}日`
    return {
      time: moment().format('HH:mm:ss'),
      choiceFlag: 0,
      nowDate: `${disposeDate}${moment().format('HH:mm:ss')}`,
      timer: null,
      designTimer: null,
      /**
         * 0、number
         * 1、date
         * 2、dateTime
         * 3、clock
         * */
      dateTypes: ['number', 'date', 'dateTime', 'clock']
    }
  },
  created () {
    let index = this.dateTypes.indexOf(this.data.clockParams.styleType)
    this.choiceFlag = index === -1 ? 0 : index
    this.designTimer = setInterval(() => {
      this.nowDate = `${this.getDate}${moment().format('HH:mm:ss')}`
    }, 1000)
  },
  mounted () {
    if (this.sceneType === 1) {
      this.timer = setInterval(() => {
        this.time = moment().format('HH:mm:ss')
      }, 1000)
    }
  },
  beforeDestroy () {
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
  methods: {
    save () {
      this.data.clockParams.styleType = this.dateTypes[this.choiceFlag]
      this.$emit('addControls', this.data, true)
    },
    closeDialog () {
      this.$emit('closeDialog')
    },
    choice (num) {
      if (this.choiceFlag === num) return false
      // 切换清空样式
      this.recoverSetting()
      this.choiceFlag = num
    },
    // 恢复默认设置
    recoverSetting () {
      let defaultStyle = this.getStyleSetting(this.data.type)
      defaultStyle && this.$_.assign(this.data, defaultStyle)
    }
  },
  computed: {
    getDate () {
      let date = moment().format('YYYY/MM/DD')
      let disposeDate = date.split('/')
      return `${disposeDate[0]}年${disposeDate[1]}月${disposeDate[2]}日`
    }
  }
}
</script>

<style lang="scss">
  .custom-page-clock-container{
    width: 100%;
    height: 100%;
    .type-choice {
      display: flex;
      justify-content: space-between;
      height: 100%;
      & > .left {
        width: 230px;
        border-right: 1px solid #DCDCDC;
        height: 100%;
        padding: 9px 9px 13px 8px;
        .clock-style-setting {
          height: calc(100% - 50px);
        }
        .operation {
          text-align: center;
          padding-top: 16px;
          .el-button {
            width: 78px;
            height: 26px;
            border-radius: 3px;
            padding: 0;
          }
          .el-button + .el-button {
            margin-left: 22px;
          }
        }
      }
      & > .right {
        width: calc(100% - 232px);
        height: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        padding: 10px 28px 0 15px;
        .right-content {
          width: 398px;
          height: 248px;
          line-height: 248px;
          text-align: center;
          border: 1px solid #D9D9D9;
          border-radius: 2px;
          position: relative;
          cursor: pointer;
          & > span {
            position: absolute;
            right: 5px;
            bottom: 7px;
            font-size: 26px;
            color: #459FFB;
          }
          & > .date {
            font-size: 40px;
            color: #8597A9;
            font-family: FZLanTingHei-H-GBK;
            font-weight: 800;
            word-wrap: break-word;
            word-break: normal;
          }
          & > .date-now {
            line-height: 50px;
            padding-top: 70px;
          }
          & > img {
            margin-bottom: -25px;
          }
        }
        .clock-content {
          img {
            margin-bottom: 0;
            margin-top: 35px;
          }
        }
      }
    }
    .clock-runtime{
      height: 100%;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      .date {
        font-size: 40px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/report/design/customPage/clock.vue